window.addEventListener("load", () => {
	createCustomHeaderSection();
	if (window.location.pathname === "/pages/distributors") {
		setTimeout(() => {
			appendIconsToFilters();
		}, 1500); // Adjust delay as needed (1000ms = 1s)
	} else {
		appendIconsToFilters();
	}
	const storeMap = document.getElementById("store_map");
	if (storeMap) {
		const observer = new MutationObserver(() => {
			setPins();
		});
		observer.observe(storeMap, { childList: true, subtree: true });
	}
});

function setPins() {
	let pinsList = [];
	let interval = setInterval(() => {
		pinsList = document.querySelectorAll('img[src*="sc-store-locator-map-21/assets/map-pin"]');
		if (pinsList.length > 0) {
			clearInterval(interval);
			pinsList.forEach(pin => {
				if (pin.src.includes("red")) {
					setPinSrc(pin, "https://www.zautomotive.com/wp-content/uploads/2023/10/dealer_128.png");
				} else if (pin.src.includes("green") || pin.src.includes("black")) {
					setPinSrc(pin, "https://www.zautomotive.com/wp-content/uploads/2023/10/installer_128.png");
				}
			});
		}
	}, 100);
}

function setPinSrc(pin, src) {
	pin.src = src;
	// pin.parentElement.style.width = "32px";
	// pin.parentElement.style.height = "32px";
	// pin.style.width = "32px";
	// pin.style.height = "32px";
}

function createCustomHeaderSection() {
	const searchBar = document.querySelector(".search_bar");

	if (searchBar) {
		const observer = new MutationObserver(() => {
			observer.disconnect(); // Disconnect before making changes

			const label = searchBar.querySelector(".main_search_label");
			if (label) label.textContent = "Address";

			const distanceLabel = searchBar.querySelector(".distance_label");
			if (distanceLabel) distanceLabel.textContent = "Radius";

			if (!searchBar.querySelector(".custom-location-icon")) {
				const locationIcon = document.createElement("div");
				locationIcon.textContent = "my_location";
				locationIcon.className = "material-symbols-outlined custom-location-icon";
				locationIcon.style.marginRight = "10px";

				const addressSearch = searchBar.querySelector("#address_search");
				if (addressSearch) {
					addressSearch.insertAdjacentElement("afterend", locationIcon);
				}
			}

			// Reconnect after a delay to prevent infinite loops
			setTimeout(() => {
				observer.observe(searchBar, { childList: true, subtree: true });
			}, 500);
		});

		const newDiv = document.createElement("div");
		newDiv.className = "custom-div";
		newDiv.style.display = "flex";
		newDiv.style.padding = "20px 0";
		newDiv.style.alignItems = "center";
		newDiv.style.gap = "10px";
		newDiv.style.flexWrap = "wrap";

		const heading = document.createElement("p");
		heading.textContent = "Please locate your nearest Dealers and Installers";
		heading.style.margin = "0";
		heading.style.marginRight = "70px";
		heading.style.fontSize = "1.6em";
		heading.style.fontWeight = "700";
		heading.style.width = "100%";

		const img1 = document.createElement("img");
		img1.setAttribute("decoding", "async");
		img1.setAttribute("width", "128");
		img1.setAttribute("height", "128");
		img1.setAttribute("src", "https://www.zautomotive.com/wp-content/uploads/2023/10/dealer_128.png");
		img1.setAttribute("class", "attachment-large size-large");
		img1.setAttribute("alt", "");
		img1.setAttribute("srcset", "https://www.zautomotive.com/wp-content/uploads/2023/10/dealer_128.png 128w, https://www.zautomotive.com/wp-content/uploads/2023/10/dealer_128-100x100.png 100w");
		img1.setAttribute("sizes", "(max-width: 128px) 100vw, 128px");
		img1.style.width = "40px";

		const paragraph1 = document.createElement("p");
		paragraph1.textContent = "Dealers";
		paragraph1.style.margin = "0";

		const img2 = document.createElement("img");
		img2.setAttribute("decoding", "async");
		img2.setAttribute("width", "128");
		img2.setAttribute("height", "128");
		img2.setAttribute("src", "https://www.zautomotive.com/wp-content/uploads/2023/10/installer_128.png");
		img2.setAttribute("class", "attachment-large size-large");
		img2.setAttribute("alt", "");
		img2.setAttribute("srcset", "https://www.zautomotive.com/wp-content/uploads/2023/10/installer_128.png 128w, https://www.zautomotive.com/wp-content/uploads/2023/10/installer_128-100x100.png 100w");
		img2.setAttribute("sizes", "(max-width: 128px) 100vw, 128px");
		img2.style.width = "40px";
		img2.style.marginLeft = "40px";

		const paragraph2 = document.createElement("p");
		paragraph2.textContent = "Installers";
		paragraph2.style.margin = "0";
		paragraph2.style.fontSize = "16px";

		const subHeading = document.createElement("p");
		subHeading.textContent = "Dealers";
		subHeading.style.marginTop = "20px";
		subHeading.style.fontSize = "24px";

		// newDiv.prepend(paragraph2);
		// newDiv.prepend(img2);
		// newDiv.prepend(paragraph1);
		// newDiv.prepend(img1);
		newDiv.prepend(heading);
		// searchBar.prepend(subHeading);
		searchBar.prepend(newDiv);
	}
}

function appendIconsToFilters() {
	// Define icons


	// Select all filter labels inside the fieldset
	document.querySelectorAll(".search_filter label").forEach(label => {
		const icons = {
			"Dealer": "https://www.zautomotive.com/wp-content/uploads/2023/10/dealer_128.png",
			"Installer": "https://www.zautomotive.com/wp-content/uploads/2023/10/installer_128.png"
		};
		const labelText = label.textContent.trim();
		console.log("appendIconsToFilters", labelText);

		// Check if the label matches Dealer or Installer
		if (icons[labelText]) {
			const img = document.createElement("img");
			Object.assign(img, {
				src: icons[labelText],
				width: 40,
				height: 40,
				className: 'appendImgDealerInstall',
				alt: labelText + " Icon"
			});
			img.style.paddingLeft = "8px"; // Add some spacing
			img.style.paddingRight = "8px"; // Add some spacing

			// Append the icon after the label
			label.prepend(img);
		}
	});
}


